import React, { createContext, useState, useContext } from "react";

const OvertimeContext = createContext();

export function OvertimeProvider({ children }) {
  const [pendingOvertimes, setPendingOvertimes] = useState(0);

  return (
    <OvertimeContext.Provider value={{ pendingOvertimes, setPendingOvertimes }}>
      {children}
    </OvertimeContext.Provider>
  );
}

export function useOvertime() {
  return useContext(OvertimeContext);
}
